import { connect } from 'react-redux';
import View from './view'

const stateToProps = (state) => state;

export default connect(stateToProps, null)(View);